import { Component, OnInit, Input, ElementRef } from '@angular/core';
import * as feather from 'feather-icons';

@Component({
  selector: 'app-feather-icons',
  templateUrl: './feather-icons.component.html',
  styleUrls: ['./feather-icons.component.scss']
})
export class FeatherIconsComponent implements OnInit {

  @Input() icon: string;
  @Input() fallbackIcon?: string; // Optional fallbackIcon input

  constructor(private elRef: ElementRef) {}

  ngOnInit() {
    const fallbackIcons = ['box', 'crosshair', 'cpu', 'globe', 'life-buoy'];

    const isValid = (name: string | undefined): boolean =>
      !!name && feather.icons.hasOwnProperty(name);

    let safeIcon: string;

    if (isValid(this.icon)) {
      safeIcon = this.icon;
    } else if (isValid(this.fallbackIcon)) {
      safeIcon = this.fallbackIcon!;
    } else {
      const randomIndex = Math.floor(Math.random() * fallbackIcons.length);
      safeIcon = fallbackIcons[randomIndex];
    }

    const svgHtml = feather.icons[safeIcon].toSvg();
    this.elRef.nativeElement.innerHTML = svgHtml;
  }
}
